import { crm } from "../../../theme";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { FaFileExcel, FaTrash, FaTruckLoading } from "react-icons/fa";
import {
  deleteSupplier,
  getSuppliers,
  saveSupplier,
} from "../../../services/supplierService";
import ImportModal from "./Company/components/ImportModal";

const AddSuppliers = () => {
  const [name, setName] = useState<string>();
  const [suppliers, setSuppliers] = useState<{ id: string; name: string }[]>(
    []
  );
  const [filteredSuppliers, setFilteredSuppliers] =
    useState<{ id: string; name: string }[]>(suppliers);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const toast = useToast();
  const { isOpen, onClose, onOpen } = useDisclosure();

  const handleSave = async () => {
    setError(undefined);
    if ((name?.length ?? 0) === 0) {
      setError("Este campo é obrigatório");
      return;
    }
    setLoading(true);
    const response = await saveSupplier(name ?? "");
    if (response) {
      toast({
        title: "Fornecedor adicionado.",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
      await getSavedSuppliers();
    }
    setLoading(false);
  };

  const remove = async (id: string) => {
    setLoading(true);
    await deleteSupplier(id);
    await getSavedSuppliers();
    toast({
      title: "Fornecedor removido.",
      status: "success",
      duration: 4000,
      isClosable: true,
    });

    setLoading(false);
  };
  const getSavedSuppliers = async () => {
    const response = await getSuppliers();
    if (response) {
      setSuppliers(response);
      setFilteredSuppliers(response);
    }
  };
  useEffect(() => {
    getSavedSuppliers();
  }, []);
  return (
    <Box>
      <Heading size="lg" mb="24px" fontWeight="normal">
        <Flex alignItems="center" gap="12px">
          <FaTruckLoading color="var(--icon-color)" /> Adicionar Fornecedores
        </Flex>
      </Heading>
      <Button
        color={crm.brand}
        borderRadius="10px"
        variant="outline"
        borderColor={crm.brand}
        _hover={{ bg: crm.brandSoft }}
        mb="16px"
        onClick={() => onOpen()}
      >
        <Flex justifyContent="center" alignItems="center" gap="8px">
          <FaFileExcel /> Importar
        </Flex>
      </Button>
      <ImportModal
        isSupplier
        getSavedCompanies={getSavedSuppliers}
        {...{ isOpen, onClose }}
      />
      <form>
        <Box width="100%" backgroundColor="white" borderRadius="12px" border={`1px solid ${crm.border}`} boxShadow={crm.shadowSm} p="24px">
          <Flex flexDirection="column">
            <Flex>
              <Heading size="sm" fontWeight="normal" marginBottom="8px">
                Nome do fornecedor
              </Heading>
              <Text color="red" fontSize="18px" marginLeft="4px">
                *
              </Text>
            </Flex>
            <Input
              value={name}
              onChange={(e) => {
                setError(undefined);
                setName(e.target.value);
              }}
            />
            {error && (
              <Text marginTop="16px" color="red">
                {error}
              </Text>
            )}
          </Flex>
        </Box>
        <Flex w="100%" justifyContent="flex-end">
          <Button
            marginY="32px"
            backgroundColor={crm.brand}
            color="white"
            borderRadius="10px"
            _hover={{ backgroundColor: crm.brandDark }}
            onClick={() => (error?.length ?? 0) === 0 && handleSave()}
            isLoading={loading}
            type="submit"
          >
            Salvar
          </Button>
        </Flex>

        <Flex
          flexDir="column"
          marginTop="32px"
          overflowY="auto"
          backgroundColor="white"
          borderRadius="12px"
          border={`1px solid ${crm.border}`}
          boxShadow={crm.shadowSm}
          p="24px"
        >
          <Heading size="md" fontWeight="normal">
            Fornecedores salvos
          </Heading>
          <Input
            placeholder="Pesquise um fornecedor"
            my="32px"
            height="40px !important"
            onChange={(e) =>
              setFilteredSuppliers((fs) => {
                const newfs = [...suppliers];
                return newfs.filter((f) =>
                  f.name.toLowerCase().includes(e.target.value.toLowerCase())
                );
              })
            }
          />
          <Flex flexDir="column" gap="16px" h="400px" overflowY="auto">
            {filteredSuppliers.map((p) => (
              <Flex key={p.id} alignItems="center" gap="8px">
                <Heading size="sm" fontWeight="normal" w="95%">
                  {p.name}
                </Heading>
                <FaTrash color={crm.danger} onClick={() => remove(p.id)} cursor="pointer" />
              </Flex>
            ))}
          </Flex>
        </Flex>
      </form>
    </Box>
  );
};

export default AddSuppliers;
